import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';
import './InnovationAwards.css';
import api from '../../../../api';

const InnovationAwards = () => {
  const [innovationData, setInnovationData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedTables, setExpandedTables] = useState({});

  useEffect(() => {
    const fetchInnovationData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/innovation-awards");
        const data = response.data;

        const rawImages = data?.banner_data?.images || [];
        const formattedImages = rawImages.map(img =>
          img && !img.startsWith("/") ? `/${img}` : img
        );

        data.banner_data.images = formattedImages;

        setInnovationData(data);
        setIsLoading(false);

      } catch (err) {
        console.error("Error fetching Innovation Awards data:", err);
        setError("Failed to load Innovation Awards data");
        setIsLoading(false);
      }
    };

    fetchInnovationData();
  }, []);

  const toggleTableRows = (index) => {
    setExpandedTables(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error || !innovationData) {
    return <div>{error}</div>;
  }

  const bannerData = innovationData.banner_data || {};
  const sections = innovationData.sections || [];

  const bannerTitle = bannerData.title || "";
  const bannerImages = bannerData.images || [];
  const mobileimage=bannerData.mobile_images ||[];


  const getVisibleRows = (rows, isExpanded) => {
    if (isExpanded || rows.length <= 8) {
      return rows;
    }
    return rows.slice(0, 8);
  };

  return (
    <>

      {bannerImages.length > 0 && (
        <DynamicBanner
          title={bannerTitle}
          bgImage={bannerImages}
          bgImageMobile={mobileimage}
        />
      )}

      <section className="innovation-section mb-5">
        <div className="container">
          <div className='row d-flex justify-content-center align-items-center'>

            {sections.map((section, sectionIndex) => {
              const isExpanded = expandedTables[sectionIndex];
              const visibleRows = getVisibleRows(section.rows || [], isExpanded);
              const hasMoreRows = (section.rows || []).length > 8;

              return (
                <div key={sectionIndex} className="mb-5">
  
                  <div className="sec-title text-center">
                    <h2>{section.title}</h2>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered table-hover awards-table">
                      <thead>
                        <tr>
                          {section.columns && section.columns.map((column, colIndex) => (
                            <th key={colIndex}>{column}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {visibleRows.map((row, rowIndex) => (
                          <tr 
                            key={rowIndex}
                            className={rowIndex >= 8 ? "hidden-rows" : ""}
                            style={{ 
                              display: rowIndex >= 8 && !isExpanded ? 'none' : 'table-row' 
                            }}
                          >
                            {row.map((cell, cellIndex) => (
                              <td key={cellIndex}>{cell || '-'}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>

                  
                  </div>
                    {hasMoreRows && (
                      <div>
                        <button
                          className="read-more-btn-faculty d-block "
                          onClick={() => toggleTableRows(sectionIndex)}
                        >
                          {isExpanded ? 'Read Less' : 'Read More'}
                        </button>
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default InnovationAwards;